@for (item of contactsElements; track $index) {
  @if (item?.['icon']) {
    <div class="d-flex align-items-center gap-6 line-height-16">
      <i class="bg-gray-700 icon {{ item?.['icon'] }}"></i>
      <span>{{ item?.['data'] }}</span>
    </div>
  } @else {
    <div>{{ item }}</div>
  }
}
